const zh = {
    ctcbot: "ctcbot",
    Home: "首页",
    Quantitative: "量化",
    Community: "社区",
    Notifications: "通知",
    Profile: "个人资料",
    pages: "页面",
    feature: "功能",
    Roadmap: "路线图",
    Faqs: "常见问题",
    member_login: "会员登录",
    admin_login: "管理员登录",
    contact_us: "联系我们",
    api_bind: "API绑定",
    invite_friend: "邀请好友",
    wallet: "钱包",
    rewards: "奖励",
    login: "登录",
    sign_in: "登录",
    register_here: "在此注册",
    not_register_yet: "还没有注册？",
    email: "邮箱",
    email_enter: "输入邮箱",
    email_address: "邮箱地址",
    email_address_enter: "请输入邮箱地址",
    forgot_password: "忘记密码",
    email_input: "请输入邮箱！",
    email_not_valid: "邮箱格式不正确！",
    password: "密码",
    password_enter: "输入密码",
    password_input: "请输入密码！",
    retype_password: "重复密码",
    retype_password_enter: "请输入重复密码",
    retype_password_input: "请再次输入密码！",
    retype_password_not_match: "两次输入的密码不匹配！",
    register: "注册",
    sign_up: "注册",
    please_input_your_username: "请输入用户名！",
    enter_username: "输入用户名",
    invitation_code: "邀请码",
    invitation_code_enter: "输入邀请码",
    invitation_code_required: "请输入您的邀请码！",
    register_now: "立即注册",
    congratulations: "恭喜",
    register_successful: "注册成功",
    Coming_Soon: "即将上线！",
    loading: "加载中...",
    submit: "提交",
    refresh: "刷新",
    add: "添加",
    confirm: "确认",
    logout: "退出",
    done: "完成",
    login_now: "立即登录",
    no_records_found: "未找到记录！",
    save: "保存",
    Load_More: "加载更多",
    we_could_not_find: "我们找不到",
    page: "页面",
    USD: "美元",
    english: "英语",
    malaysia: "马来语",
    chinese: "中文",
    verification_code: "验证码",
    verification_code_enter: "请输入验证码",
    verification_code_required: "验证码为必填项",
    verification_code_not_valid: "验证码无效！请输入有效验证码。",
    input_your_verification_code: "请输入验证码",
    otp_not_match: "您输入的OTP不匹配！",
    send_code: "发送验证码",
    get_code: "获取验证码",
    id: "ID",
    affiliate_program: "推广计划",
    team: "团队",
    activate: "激活",
    not_activated_yet: "尚未激活",
    activate_profit: "激活收益",
    activate_profit_today: "今日激活收益",
    activate_profit_total: "累计激活收益",
    direct_quantification: "直推量化",
    team_quantification: "团队量化",
    direct_referrals: "直推人数",
    grade: "等级",
    account: "账号",
    number_of_team: "团队人数",
    registration_time: "注册时间",
    reward_details: "奖励详情",
    full_details: "详细信息",
    bot_quantification: "机器人量化",
    profit: "利润",
    pair: "交易对",
    description: "描述",
    profit_quantification: "收益量化",
    total_profit_today: "今日总收益",
    total_profit_earned: "累计收益",
    share: "分享",
    helpline: "帮助中心",
    account_problem: "账号问题",
    trading_problem: "交易问题",
    suggestion_opinions: "意见反馈",
    report_violation: "违规举报",
    money_flow_problem: "资金问题",
    api_binding_issues: "API绑定问题",
    bug_problem: "漏洞问题",
    other: "其他",
    security_centre: "安全中心",
    my_policy_settings: "我的策略设置",
    system_setting: "系统设置",
    change_email: "修改邮箱",
    new_email_enter: "请输入新邮箱",
    new_email_verification_code: "新邮箱验证码",
    new_email_verification_code_enter: "请输入新邮箱验证码",
    safety_email_verification_Code: "安全邮箱验证码",
    please_enter_the_email_verification_code: "请输入邮箱验证码",
    change_password: "修改密码",
    enter_old_password: "请输入旧密码",
    input_your_old_password: "请输入旧密码！",
    please_enter_password: "请输入密码",
    please_enter_retype_password: "请输入重复密码",
    delete_account: "删除账号",
    delete_account_note: "注意：删除账号后，所有信息将被清空且无法恢复。",
    delete_account_following_conditions: "以下情况无法删除账号：",
    delete_account_following_conditions_1: "- 账号存在错误。",
    delete_account_following_conditions_2: "- 策略同步尚未取消。",
    delete_account_following_conditions_3: "- 所有交易策略尚未结束。",
    delete_account_following_conditions_4: "- API绑定未解除。",
    profile_information: "个人信息",
    change_avatar: "更换头像",
    change_profile_image: "更换头像",
    name: "姓名",
    username: "用户名",
    my_inviter_id: "我的邀请人ID",
    level: "等级",
    status: "状态",
    language: "语言",
    transaction_password: "交易密码",
    new_password: "新密码",
    please_enter_new_password: "请输入新密码",
    Please_input_your_new_password: "请输入新密码！",
    google_verification_code: "Google验证码",
    withdraw_address_management: "提现地址管理",
    bank_management: "银行管理",
    touch_id_pin: "指纹 & PIN",
    valuation_method: "计价方式",
    theme_mode: "主题模式",
    dark_mode: "深色模式",
    firmware_version: "固件版本",
    Latest_Announcement: "最新公告",
    Announcement_Detail: "公告详情",
    binding: "绑定",
    precautions: "注意事项",
    see_the_instructions: "查看说明",
    see_the_instructions_point_1: "1. 请确认API权限已勾选“启用现货&杠杆交易”。",
    see_the_instructions_point_2: "2. 请输入正确的API，不要输入特殊字符。",
    see_the_instructions_point_3: "3. 信任IP：",
    access_key: "API Key",
    access_key_enter: "请输入API Key",
    secret_key: "Secret Key",
    secret_key_enter: "请输入Secret Key",
    access_key_required: "API Key为必填项。",
    secret_key_required: "Secret Key为必填项。",
    bound: "已绑定",
    unbound: "未绑定",
    unbind: "解绑",
    bind_now: "立即绑定",
    member_center: "会员中心",
    current_level_lower_info: "您当前等级低于该等级",
    level_membership_info: "该等级会员权益不可用，请先升级！",
    B0: "B0",
    no_record_found: "无记录",
    cycle: "循环",
    one_shot: "一键执行",
    quantity: "数量",
    latest_price: "最新价格",
    floating_profit: "浮动收益",
    increase: "涨幅",
    code_copy: "复制代码",
    code_copy_successfully: "复制成功！",
    copy_link: "复制链接",
    link_copy_successfully: "链接复制成功！",
    my_invitation_code: "我的邀请码",
    my_policy_setting: "我的策略设置",
    no_notifications: "暂无通知",
    logs: "日志",
    no_logs: "暂无日志",
    market: "市场",
    amount: "金额",
    price: "价格",
    fee: "手续费",
    total: "总计",
    your_account_not_activated_now: "您的账号尚未激活，请先激活账号！",
    id_not_found: "未找到ID！",
    BUY: "买入",
    are_you_sure_BUY: "确认买入？",
    SELL: "卖出",
    are_you_sure_SELL: "确认卖出？",
    usdt: "USDT",
    enter_USDT: "请输入USDT",
    USDT_required: "USDT为必填项！",
    trade_bot: "交易机器人",
    position_amount: "持仓金额",
    avg_price: "平均价格",
    numbers_of_call_margin: "补仓次数",
    position_quantity: "持仓数量",
    current_price: "当前价格",
    return_rate: "回报率",
    first_preset_buy_in_price: "首单预设买入价",
    first_buy_amount: "首单买入金额",
    margin_call_limit: "补仓限制",
    take_profit_ratio: "止盈比例",
    take_profit_call_back: "止盈回调",
    buy_in_callback: "买入回调",
    trade_setting: "交易设置",
    stop: "停止",
    start: "开始",
    bot_not_found: "未找到机器人详情！",
    margin_configuration: "补仓配置",
    Margin_call_Drop: "补仓跌幅",
    Multiple_Of_Times: "倍数",
    trade_settings: "交易设置",
    first_buy_in_amount: "首单买入金额",
    open_position_doubled: "开仓加倍",
    wallet_address_not_foud: "未找到钱包地址！",
    transfer: "转账",
    transfer_details: "转账详情",
    confirm_transfer: "确认转账",
    deposit: "充值",
    withdraw: "提现",
    deposit_details: "充值详情",
    chain_name: "链名称",
    deposit_address: "充值地址",
    USDT_deposit_address: "USDT充值地址",
    address_can_only_receive_USDT: "此地址仅支持USDT充值",
    code_link: "代码链接",
    risk_disclaimer: "风险提示",
    deposit_risk_disclaimer_point_1: "1. 请勿充值非USDT资产，否则资产将无法找回。",
    deposit_risk_disclaimer_point_2: "2. 非USDT资产充值将不予处理。",
    deposit_risk_disclaimer_point_3: "3. 未激活账号无法提现。",
    withdrawal_risk_disclaimer_point_1: "1. 单笔最低提现金额为10 USDT",
    withdrawal_risk_disclaimer_point_2: "2. 提现将在24小时内处理。",
    withdrawal_risk_disclaimer_point_3: "3. 请提供正确的BEP20 USDT地址，以避免资产损失。",
    URI_not_found: "未找到URI！",
    TXID: "TXID",
    Total_Assets_Converted_USDT: "总资产折合USDT",
    history_record: "历史记录",
    the_recipient_wallet_username_field_is_required: "接收方钱包用户名为必填项。",
    the_amount_field_is_required: "金额为必填项。",
    the_verification_code_field_is_required: "验证码为必填项。",
    verification_code_not_valid_enter_valid: "验证码无效！请输入有效验证码。",
    Receipient_UserID: "接收方用户ID",
    transfer_quantity: "转账数量",
    All: "全部",
    Available: "可用",
    Transaction_Fees: "交易手续费",
    the_address_field_is_required: "地址为必填项。",
    withdrawal: "提现",
    withdrawal_details: "提现详情",
    Withdraw_details: "提现详情",
    withdrawal_address: "提现地址",
    withdrawal_address_enter: "请输入提现地址",
    withdrawal_quantity: "提现数量",
    minimum_withdraw_amount: "最低提现金额",
    receive_amount: "到账金额",
    confirm_withdrawal: "确认提现",
    Scan_QR_Code: "扫码二维码",
    Add_Bank: "添加银行",
    Add_Bank_input: "请输入银行名称！",
    Add_Bank_enter: "请输入银行名称",
    Account_Holder: "开户人",
    Account_Holder_input: "请输入开户人姓名！",
    Account_Holder_enter: "请输入开户人姓名",
    Account_Number: "账号",
    Account_Number_input: "请输入银行账号！",
    Account_Number_enter: "请输入银行账号",
    Branch: "分行",
    Branch_input: "请输入分行名称！",
    Branch_enter: "请输入分行名称",
    City: "城市",
    City_input: "请输入城市！",
    City_enter: "请输入城市",
    the_wallet_address_field_is_required: "钱包地址为必填项。",
    Add_Wallet: "添加钱包",
    Currency: "币种",
    Mainnet: "主网",
    Address: "地址",
    Wallet_Address: "钱包地址",
    Wallet_Label: "钱包标签",
    Bank_Management: "银行管理",
    Wallet_Management: "钱包管理",
    WhiteList: "白名单",
    Trading_Profit: "交易收益",
    Chart: "图表",
    Chart_detail: "图表详情",
    fuel_balance_is_insufficient: "燃料余额不足，钱包至少需要10 USDT。余额低于5 USDT时，您的机器人将停止运行。",
    view_details: "查看详情",
    view_monthly_report: "查看月报",
    total_daily_trading_profit: "每日总交易收益",
    spot_trading: "现货交易",
    Trading_Details: "交易详情",
    bot_reward_details: "机器人奖励详情",
    profit_details: "收益详情",
    LiveChatSupport: "在线客服",
    need_to_active_account: "需要先激活账号。",
    whole_position: "整仓",
    distributed_and_take_profit_allocation: "分仓及止盈分配",
    sub_position: "子仓",
    sub_position_take_profit_callback: "子仓止盈回调",
    strategy_period: "策略周期",
    order_list: "订单列表",
    sell_all: "全部卖出",
    are_you_sure_SELL_all: "确定全部卖出？",
    total_order_number: "订单总数",
    layer: "层级",
    layer_call_limit: "层级补仓限制",
    all_layer_buy_in_amount: "所有层级买入金额",
    all_layer_take_profit_ratio: "所有层级止盈比例",
    all_layer_take_profit_call_back: "所有层级止盈回调",
    all_layer_buy_in_callback: "所有层级买入回调",
    all_layer_margin_call_back: "所有层级补仓回调",
    are_you_sure_you: "您确定要",
    order_: "订单？",
    CONNECT_TO_ACCESS_HOLDER_AREA: "连接持有者区域",
    CONNECT_WALLET: "连接钱包",
    terms_conditions: "条款与条件",
    terms_conditions_1: "1. 钱包中需至少持有一个ctcbot NFT。",
    terms_conditions_2: "2. 这是只读连接，不会触发任何区块链交易或产生费用。",
    terms_conditions_3: "3. 请勿泄露您的私钥。我们绝不会向您索取私钥。",
    Copy_IP_address: "复制IP地址",
    Copy_IP_address_msg: "IP地址已复制！",
    gas_fees: "Gas费用",
    gas_fees_details: "Gas费用详情",
    convert: "转换",
    confirm_conver: "确认转换",
    convert_quantity: "转换数量",
    copy_id: "ID已复制！",
    all_layer_buy_in_ratio: "所有层级买入比例",
    Order_Amount: "订单金额",
    Max_trade: "最大交易次数",
    BOLL_Bot: "CTS 机器人",
    DCA: "DCA",
    DCA_Bot: "DCA 机器人",
    AI_Bot: "AI 机器人",
    entry_price: "进场价格",
    Market_Price: "市场价格",
    Data_not_found: "未找到数据！",
    AutoTrade: "自动交易",
    disclaimer: "免责声明",
    auto_trade_disclaimer: "请确保USDT钱包余额足够支付手续费，否则机器人可能停止运行。",
    tutorial: "教程",
    view: "查看",
    download: "下载",
    Select_BOT: "选择机器人",
    Uncheck_All_Bots: "取消全选",
    All_Bots: "所有机器人",
    please_select_one_bot: "请选择一个机器人。",
    Max_Pairs: "最大交易对数量",
    Select_Max_Pairs: "选择最大交易对",
    please_select_at_least_one_order: "请至少选择一个订单。",
    are_you_sure_you_want_to_sell_all_order: "您确定要卖出全部订单？",
    are_you_want_to_start_bot: "确定要启动机器人吗",
    ai_bot_order_list: "AI机器人订单列表",
    PnL_per: "盈亏 (%)：",
    processing_: "处理中...",
    Sell_Selected_Order: "卖出选中订单",
    line: "线",
    Stratergy: "策略",
    Stratergy_1: "策略 1",
    Stratergy_2: "策略 2",
    Stratergy_3: "策略 3",
    Time_Frame: "时间周期",
    Minute: "分钟",
    Hour: "小时",
    CTS_Bot: "CTS机器人",
    CTS_Bot_Order_List: "CTS机器人订单列表",
    entry_gap_per: "进场差距(%)",
    amount_double: "金额加倍",
    No: "否",
    Yes: "是",
    take_profit_per: "止盈(%)",
    Multiply: "倍数",
    Instant_Buy: "立即买入",
    Trailing_Stop: "移动止损",
    Max_Trades: "最大交易次数",
    dca_bot_order_list: "DCA机器人订单列表",
    Enter_Email: "请输入邮箱",
    GET_STARTED_NOW: "立即开始",
    online_trading_never_been_this_easy: "在线交易从未如此简单！",
    online_trading_never_been_this_easy_desc: "除了精美的界面，Cts Bot 是一个功能强大的核心交易平台，让您的加密之旅安全起航",
    buy_and_sell_cryptocurrency: "买卖加密货币",
    buy_and_sell_cryptocurrency_desc: "买卖加密货币",
    buy_and_sell_cryptocurrency_desc_2: "简化交易体验，使您无需直接与交易所交互即可管理投资组合。",
    emotionless_trading: "无情绪交易",
    emotionless_trading_desc: "加入20%聪明交易者的行列，通过交易机器人保持系统化、无情绪的交易方式。",
    higher_trading_speed: "更高交易速度",
    higher_trading_speed_desc: "在你读完这一句话的时间里，机器人可能已经完成多笔盈利交易。",
    backtesting_and_paper_trading: "回测与模拟交易",
    backtesting_and_paper_trading_desc: "飞行员通过模拟训练，而交易者也应通过市场模拟提升技能。",
    risk_diversification: "风险分散",
    risk_diversification_desc: "交易机器人帮助您避免“把鸡蛋放在同一个篮子里”。加密市场波动大，风险分散是关键策略。",
    consistent_trading_discipline: "持续交易纪律",
    consistent_trading_discipline_desc: "学习语言、跑马拉松、修禅，都需要纪律，交易也一样。",
    our_advantages: "我们的优势",
    our_advantages_1: "资金安全自主管控在自己的币安账户中",
    our_advantages_2: "实时数据透明",
    our_advantages_3: "24/7自动交易",
    our_advantages_4: "操作简易",
    our_advantages_5: "完全自动化",
    our_advantages_6: "月化收益 5%-20%",
    our_advantages_7: "人性化 + 数据化交易",
    our_advantages_8: "高频技术 · 系统防怠慢",
    our_advantages_9: "自由选择启动机器人或全程托管",
    robot_strategy: "机器人策略",
    robot_strategy_dca_desc: "最常见的普通机器人策略，适用于牛市或看好的币种，并带有分仓模式，避免深套。",
    robot_strategy_bollinger_middle: "布林中轨",
    robot_strategy_bollinger_middle_desc: "智能机器人，在合适的时机投机买入。每单都采用分仓模式（重点：只做一单，不会追单），安全可靠。",
    robot_strategy_bollinger_bottom: "布林下轨",
    robot_strategy_bollinger_bottom_desc: "超智能机器人，更稳更保守，只在最稳妥时机买入，也是低资金也能稳健盈利的策略之一，同样采用分仓模式（只做一单，不追单）。",
    Why_do_quantitative_trading_strategies_sometimes_result_in_losses: "为什么量化交易有时也会亏损？",
    Why_do_quantitative_trading_strategies_sometimes_result_in_losses_1: "不会选币",
    Why_do_quantitative_trading_strategies_sometimes_result_in_losses_2: "没有交易策略",
    Why_do_quantitative_trading_strategies_sometimes_result_in_losses_3: "缺乏专业认知",
    Why_do_quantitative_trading_strategies_sometimes_result_in_losses_4: "资金不足",
    Why_do_quantitative_trading_strategies_sometimes_result_in_losses_5: "单向交易：涨赚钱，跌容易被套",
    fuel_reminder: "燃料提醒",
    fuel_reminder_1: "燃料费少于本金2%时提醒",
    fuel_reminder_2: "燃料少于本金1%时机器人停止操作",
    fuel_reminder_3: "如发现用户在币安手动卖出盈利（例如100 USDT），将惩罚 50%（平台25% + 正常分配25%）；3次后永久停止服务",
    fuel_reminder_4: "平台所有交易必须由机器人自动操作或平台内手动卖出",
    important_reminder: "重要提醒",
    important_reminder_desc: "投资皆有风险！<br />无论情感如何<br />平台概不负责",
    easy_way_to_trade_your_cryptocurrency: "最轻松的方式交易<br />您的加密货币",
    easy_way_to_trade_your_cryptocurrency_desc: "与世界最专业的投资者一样增长您的投资组合，我们让机构级投资工具向所有人开放。",
    LEARN_MORE: "了解更多",
    copyright_string: "© Copyright 2023. All Rights Reserved.",
    dont_have_an_account: "还没有账号？ ",
    sign_up_here: "点击注册",
    crafted_with_: "Crafted with 2023 Cts Bot",
    how_to_qualify_next_level: "如何晋级到更高等级",
    please_activate_your_CTS_bot: "请先激活CTS机器人",
    membership_rights: "会员权益",
    please_activate_ctsbot_for_more_membership_rights: "请激活Ctsbot以获得更多会员权益",
    direct: "直推",
    direct_active: "直推激活",
    members: "成员",
    active_direct: "激活直推",
    active_team_members: "激活团队成员",
    bot_activation_earning: "机器人激励收益",
    bot_activation_earning_level_1: "等级1：25%",
    bot_activation_earning_level_2: "等级2：10%",
    bot_activation_earning_level_3: "等级3：5%",
    bot_activation_earning_level_4: "等级4：5%",
    bot_activation_earning_level_5: "等级5：5%",
    bot_activation_earning_level_6: "等级6：5%",
    profit_sharing_earning: "利润分成收益",
    profit_sharing_earning_level_1_20: "等级1：20%",
    profit_sharing_earning_level_1: "等级1：25%",
    profit_sharing_earning_level_2: "等级2：15%",
    profit_sharing_earning_level_3: "等级3：8%",
    profit_sharing_earning_level_4: "等级4：4%",
    profit_sharing_earning_level_5: "等级5：4%",
    profit_sharing_earning_level_6: "等级6：2%",
    profit_sharing_earning_level_7: "等级7：2%",
    at_least: "至少",
    profit_sharing_pool: "利润分成池",
    b4_bot_fee_pool: "B4机器人手续费池（5%）",
    b4_bot_fee_pool_desc_1: "##本人必须为B4，仅统计直推B4及以上，每个B4及以上的直推算1份平分5%池",
    b4_profit_sharing_pool: "B4利润分成池（5%）",
    b4_profit_sharing_pool_desc_1: "##本人必须为B4，仅统计直推B4及以上，每个直推1份平分5%池",
    b5_bot_fee_pool: "B5机器人手续费池（3%）",
    b5_bot_fee_pool_desc_1: "##本人必须为B5，仅统计直推B5及以上，每个直推算1份平分3%池",
    b5_bot_fee_pool_desc_2: "**达到B5后将自动获得B4池一份",
    b5_profit_sharing_pool: "B5利润分成池（3%）",
    b5_profit_sharing_pool_desc_1: "##本人必须为B5，仅统计直推B5及以上，每个直推算1份平分3%池",
    b5_profit_sharing_pool_desc_2: "**达到B5后将自动获得B4利润池一份",
    you_are_now_highest_level_at_B6: "您现在是最高等级 B6",
    b6_bot_fee_pool: "B6机器人手续费池（2%）",
    b6_bot_fee_pool_desc_1: "##本人必须为B6，仅统计直推B6及以上，每个直推算1份平分2%池",
    b6_bot_fee_pool_desc_2: "**达到B6后自动获得B4及B5手续费池各一份",
    b6_profit_sharing_pool: "B6利润分成池（2%）",
    b6_profit_sharing_pool_desc_1: "##本人必须为B6，仅统计直推B6及以上，每个直推算1份平分2%池",
    b6_profit_sharing_pool_desc_2: "**达到B6后自动获得B4及B5利润池各一份",
    old_Password: "旧密码",
    subscription: "订阅",
    extend_subscription: "延长订阅",
    active: "激活",
    usdt_balance: "USDT余额",
    monthly_profit: "月收益",
    details: "详情",
    select_a_date_range_for_trading_profit: "选择交易收益时间范围",
    select_a_date_range_for_bot_quantification: "选择机器人量化时间范围",
    select_a_date_range_for_Profit_quantification: "选择收益量化时间范围",
    bot: "机器人",
    coin_qty: "币数量",
    usdt_qty: "USDT数量",
    average_buy_price: "平均买价",
    sell_price: "卖出价格",
    downloaded_successfully: "下载成功！",
    failed_to_download_PDF: "PDF下载失败。",
    select_a_date_range: "选择日期范围",
    please_enter_receipient_UserID: "请输入接收方用户ID",
    receiver_name: "接收人姓名：",
    please_enter_address: "请输入地址",
    optional: "可选",
    "Subscription Expire Date": "订阅到期日期",
    Level: "等级",
    "Inviter ID": "邀请人ID",
};
export default zh;
